import { nextArrow, prevArrow } from "@/global/slick-options";

const accreditationsSlider = document.querySelectorAll( '[data-slider="accreditations-slider"' );
if ( accreditationsSlider.length ) {
    accreditationsSlider.forEach( slider => {
        if ( slider.dataset.sliderLayout == 'rows' ) {
            const arrowsWrap = slider.querySelector( '.accreditation-arrows' );
            const dotsWrap = slider.parentElement.querySelector( '#accreditation-dots' );
            jQuery( slider ).slick( {
                slidesToShow: 6,
                slidesToScroll: 1,
                fade: false,
                dots: false,
                rows: 0,
                centerMode: false,
                centerPadding: '0',
                focusOnSelect: false,
                autoplay: true,
                autoplaySpeed: 2000,
                arrows: true,
                nextArrow,
                prevArrow,
                appendArrows: arrowsWrap,
                appendDots: dotsWrap,
                // appendDots: jQuery('#accreditation-dots'),
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        }
                    }
                ]
            } );
        } else if ( slider.dataset.sliderLayout == 'columns' ) {
            jQuery( slider ).slick( {
                dots: false,
                infinite: true,
                speed: 300,
                slidesToShow: 3,
                rows: 3,
                slidesToScroll: 1,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 4000,
                pauseOnHover: true,
                pauseOnFocus: true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            rows: 1,
                            centerMode: true,
                        }
                    },
                ]
            } );
        }
    } );
}
